import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import DoctorProfile from "./components/DoctorProfile";
import Login from "./components/Login";
import SporeIndex from "./components/SporeIndex";
import MiniGame from "./components/MiniGame";
import { Toaster } from "./components/ui/sonner";
import { ErrorBoundary } from "./components/ErrorBoundary";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Protected = ({ auth, onLogin, children }) => (auth ? children : <Login onLogin={onLogin} />);

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => localStorage.getItem('subterra_auth') === 'true' && !!localStorage.getItem('subterra_user')
  );
  const [currentUser, setCurrentUser] = useState(() => localStorage.getItem('subterra_user'));

  const handleLogin = (username) => {
    setIsAuthenticated(true);
    setCurrentUser(username);
    localStorage.setItem('subterra_auth', 'true');
    localStorage.setItem('subterra_user', username);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setCurrentUser(null);
    localStorage.removeItem('subterra_auth');
    localStorage.removeItem('subterra_user');
    window.location.href = "/";
  };


  return (
    <div className="App">
      <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public page */}
          <Route path="/spore-index" element={<SporeIndex />} />

          {/* Protected pages */}
          <Route
            path="/"
            element={
              <Protected auth={isAuthenticated} onLogin={handleLogin}>
                <Dashboard currentUser={currentUser} onLogout={handleLogout} />
              </Protected>
            }
          />
          <Route
            path="/doctor/:id"
            element={
              <Protected auth={isAuthenticated} onLogin={handleLogin}>
                <DoctorProfile currentUser={currentUser} onLogout={handleLogout} />
              </Protected>
            }
          />
          <Route
            path="/doctor/:id/play"
            element={
              <Protected auth={isAuthenticated} onLogin={handleLogin}>
                <MiniGame />
              </Protected>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
